import { render, staticRenderFns } from "./NovoAgendamento.vue?vue&type=template&id=4f45c2d9"
import script from "./NovoAgendamento.vue?vue&type=script&lang=js"
export * from "./NovoAgendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports